import * as React from 'react';
import { Suite } from 'shared';
import { token, zVar } from '../../ui/theme';
import './trump-reveal.css';

/*
 * TrumpReveal — the flourish shown when trump is set for a new set. The parent
 * (setback.tsx) mounts this for ~1.5s whenever the trump suit changes; the CSS
 * animation handles the pop-in and fade-out. Rendered inside <Stage>, so it
 * scales with the board.
 */

const SUIT_GLYPH: Record<Suite, string> = {
  [Suite.Hearts]: '♥',
  [Suite.Diamonds]: '♦',
  [Suite.Spades]: '♠',
  [Suite.Clubs]: '♣',
};

const isRedSuit = (s: Suite) => s === Suite.Hearts || s === Suite.Diamonds;

interface Props {
  suite: Suite;
}

export const TrumpReveal: React.FC<Props> = ({ suite }) => (
  <div className="trump-reveal" style={{ zIndex: zVar('z-modal') }}>
    <div className="trump-reveal__inner">
      <span
        className="trump-reveal__glyph"
        style={{
          color: isRedSuit(suite) ? token('color-lose') : token('color-text'),
        }}
      >
        {SUIT_GLYPH[suite]}
      </span>
      <span className="trump-reveal__label">{suite} is trump</span>
    </div>
  </div>
);

export default TrumpReveal;
